import { useLocation } from 'react-router-dom';

type UseEditModeType = {
  isEditMode: boolean;
};

export const useEditMode = (): UseEditModeType => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const stepName = query.get('stepName');
  const entityId = query.get('entityId');

  const isPolicyStep = stepName === 'policy_effective_date';

  const isEditMode = !!(
    query.get('edit') === 'true' &&
    (entityId || isPolicyStep)
  );

  return {
    isEditMode,
  };
};
